export const SLACK_INSTALLATION_ERROR_CODE =
  'slack_oauth_installer_authorization_error';
export const SLACK_USER_NOT_FOUND = 'slack_user_not_found';
